export default {"src":"/_next/static/media/logo.d6978eac.svg","height":77,"width":190,"blurWidth":0,"blurHeight":0};